var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vld-parent"},[_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":true},on:{"update:active":function($event){_vm.isLoading=$event}}}),(_vm.noOrgs)?[_c('not-found',{attrs:{"text-key":'NoOrganizationExist',"size":'l'}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }